module.exports = __webpack_public_path__ + "static/media/team-rating.ebee9697.svg";